<template lang="pug">
#content.snap-content
  .overlay(@click="hide()")
  Marquee(:class="{ 'd-none': !whiteLabel }")
  toolBar
  .content-center
    .pagepanel
      .page-group
        // General rules
        router-link(
          href="javascript:void(0);" 
          to="/mobile/rules/page-betting-rules-general"
        )
          .betting-rules-item.mt-2
            span {{ $t("ui.general_betting_rules") }}
        
        router-link(
          href="javascript:void(0);" 
          to="/mobile/rules/page-betting-rules-general-market"
        )
          .betting-rules-item.mt-2
            span {{ $t("ui.general_rules_market") }}
        // Sports rules - dynamically generated
        router-link(
          v-for="sport in sportsRules" 
          :key="sport.key"
          href="javascript:void(0);" 
          :to="sport.route"
        )
          .betting-rules-item.mt-2
            img.icon(
              v-if="sport.icon" 
              :src="sport.icon"
            )
            span {{ $t(sport.translationKey) }}
        
        // Special rules
        router-link(
          href="javascript:void(0);" 
          to="/mobile/rules/page-betting-rules-slots"
        )
          .betting-rules-item.mt-2
            span {{ $t("ui.slots_rules") }}
  footerNav
</template>


<script>
import toolBar from "@/components/mobile/toolBar";
import footerNav from "@/components/mobile/footerNav";
import Marquee from "@/components/mobile/mainPanelControl/marquee";
import config from "@/config";

export default {
  name: 'BettingRules',
  components: {
    toolBar,
    footerNav,
    Marquee
  },
  computed: {
    whiteLabel() {
      return config.whiteLabel == "1";
    },
    sportsRules() {
      return [
        // Major sports
        { key: 'soccer', route: '/mobile/rules/page-betting-rules-soccer', icon: '/images/icon-sport-svg/1.svg?v=12', translationKey: 'ui.soccer' },
        { key: 'basketball', route: '/mobile/rules/page-betting-rules-basketball', icon: '/images/icon-sport-svg/2.svg?v=12', translationKey: 'ui.basketball' },
        { key: 'tennis', route: '/mobile/rules/page-betting-rules-tennis', icon: '/images/icon-sport-svg/7.svg?v=12', translationKey: 'ui.tennis' },
        { key: 'baseball', route: '/mobile/rules/page-betting-rules-baseball', icon: '/images/icon-sport-svg/8.svg?v=12', translationKey: 'ui.baseball' },
        { key: 'american-football', route: '/mobile/rules/page-betting-rules-american-football', icon: '/images/icon-sport-svg/6.svg?v=12', translationKey: 'ui.american_football' },
        
        // Other sports
        { key: 'athletics', route: '/mobile/rules/page-betting-rules-athletics', icon: '/images/icon-sport-svg/34.svg?v=12', translationKey: 'ui.athletics' },
        { key: 'aussie-rules-football', route: '/mobile/rules/page-betting-rules-aussie-rules-football', icon: '/images/icon-sport-svg/25.svg?v=12', translationKey: 'ui.aussie_rules_football' },
        { key: 'badminton', route: '/mobile/rules/page-betting-rules-badminton', icon: '/images/icon-sport-svg/3.svg?v=12', translationKey: 'ui.badminton' },
        { key: 'bandy', route: '/mobile/rules/page-betting-rules-bandy', icon: '/images/icon-sport-svg/23.svg?v=12', translationKey: 'ui.bandy' },
        { key: 'beach-soccer', route: '/mobile/rules/page-betting-rules-beach-soccer', icon: '/images/icon-sport-svg/17.svg?v=12', translationKey: 'ui.beach_soccer' },
        { key: 'boxing', route: '/mobile/rules/page-betting-rules-boxing', icon: '/images/icon-sport-svg/19.svg?v=12', translationKey: 'ui.boxing' },
        { key: 'cricket', route: '/mobile/rules/page-betting-rules-cricket', icon: '/images/icon-sport-svg/12.svg?v=12', translationKey: 'ui.cricket' },
        { key: 'cycling', route: '/mobile/rules/page-betting-rules-cycling', icon: '/images/icon-sport-svg/31.svg?v=12', translationKey: 'ui.cycling' },
        { key: 'darts', route: '/mobile/rules/page-betting-rules-darts', icon: '/images/icon-sport-svg/16.svg?v=12', translationKey: 'ui.darts' },
        { key: 'field-hockey', route: '/mobile/rules/page-betting-rules-field-hockey', icon: '/images/icon-sport-svg/30.svg?v=12', translationKey: 'ui.field_hockey' },
        { key: 'futsal', route: '/mobile/rules/page-betting-rules-futsal', icon: '/images/icon-sport-svg/1.svg?v=12', translationKey: 'ui.futsal' },
        { key: 'gaelic-football', route: '/mobile/rules/page-betting-rules-gaelic-football', icon: '/images/icon-sport-svg/27.svg?v=12', translationKey: 'ui.gaelic_football' },
        { key: 'golf', route: '/mobile/rules/page-betting-rules-golf', icon: '/images/icon-sport-svg/10.svg?v=12', translationKey: 'ui.golf' },
        { key: 'handball', route: '/mobile/rules/page-betting-rules-handball', icon: '/images/icon-sport-svg/18.svg?v=12', translationKey: 'ui.handball' },
        { key: 'hurling', route: '/mobile/rules/page-betting-rules-hurling', icon: '/images/icon-sport-svg/26.svg?v=12', translationKey: 'ui.hurling' },
        { key: 'ice-hockey', route: '/mobile/rules/page-betting-rules-ice-hockey', icon: '/images/icon-sport-svg/9.svg?v=12', translationKey: 'ui.ice_hockey' },
        { key: 'kabbadi', route: '/mobile/rules/page-betting-rules-kabbadi', icon: '/images/icon-sport-svg/39.svg?v=12', translationKey: 'ui.kabbadi' },
        { key: 'mma', route: '/mobile/rules/page-betting-rules-mma', icon: '/images/icon-sport-svg/35.svg?v=12', translationKey: 'ui.mma' },
        { key: 'motorsports', route: '/mobile/rules/page-betting-rules-motorsports', icon: '/images/icon-sport-svg/14.svg?v=12', translationKey: 'ui.motorsports' },
        { key: 'muay-thai', route: '/mobile/rules/page-betting-rules-muay-thai', icon: '/images/icon-sport-svg/15.svg?v=12', translationKey: 'ui.muay_thai' },
        { key: 'netball', route: '/mobile/rules/page-betting-rules-netball', icon: '/images/icon-sport-svg/37.svg?v=12', translationKey: 'ui.netball' },
        { key: 'rugby', route: '/mobile/rules/page-betting-rules-rugby', icon: '/images/icon-sport-svg/13.svg?v=12', translationKey: 'ui.rugby' },
        { key: 'sepak-takraw', route: '/mobile/rules/page-betting-rules-sepak-takraw', icon: '/images/icon-sport-svg/38.svg?v=12', translationKey: 'ui.sepak_takraw' },
        { key: 'snooker', route: '/mobile/rules/page-betting-rules-snooker', icon: '/images/icon-sport-svg/5.svg?v=12', translationKey: 'ui.snooker' },
        { key: 'squash', route: '/mobile/rules/page-betting-rules-squash', icon: '/images/icon-sport-svg/21.svg?v=12', translationKey: 'ui.squash' },
        { key: 'table-tennis', route: '/mobile/rules/page-betting-rules-table-tennis', icon: '/images/icon-sport-svg/4.svg?v=12', translationKey: 'ui.table_tennis' },
        { key: 'volleyball', route: '/mobile/rules/page-betting-rules-volleyball', icon: '/images/icon-sport-svg/11.svg?v=12', translationKey: 'ui.volleyball' },
        { key: 'water-polo', route: '/mobile/rules/page-betting-rules-water-polo', icon: '/images/icon-sport-svg/28.svg?v=12', translationKey: 'ui.water_polo' },
        { key: 'winter-sports', route: '/mobile/rules/page-betting-rules-winter-sports', icon: '/images/icon-sport-svg/29.svg?v=12', translationKey: 'ui.winter_sports' },
        
        // Special categories
        { key: '4d-special', route: '/mobile/rules/page-betting-rules-4d-special', icon: '/images/icon-sport-svg/40.svg?v=12', translationKey: 'ui.fd' },
        // { key: 'kof', route: '/mobile/rules/page-betting-rules-kof', icon: '/images/icon-sport-svg/43.svg?v=12', translationKey: 'ui.kof' },
        // { key: 'sfv', route: '/mobile/rules/page-betting-rules-sfv', icon: '/images/icon-sport-svg/42.png?v=12', translationKey: 'ui.sfv' },
        // { key: 'ufc', route: '/mobile/rules/page-betting-rules-ufc', icon: '/images/icon-sport-svg/43.svg?v=12', translationKey: 'ui.ufc' },
        // { key: 'vgames', route: '/mobile/rules/page-betting-rules-vgames', icon: '/images/icon-other/v-games.svg?v=12', translationKey: 'V-GAMES' },
        { key: 'virtual-sports', route: '/mobile/rules/page-betting-rules-virtual-sports', icon: '/images/icon-other/v-games.svg?v=12', translationKey: 'VIRTUAL SPORTS' },
        { key: 'archery', route: '/mobile/rules/page-betting-rules-archery', icon: '/images/icon-sport-svg/24.svg?v=12', translationKey: 'ui.archery' },
        { key: 'olympic', route: '/mobile/rules/page-betting-rules-olympic', icon: '/images/icon-sport-svg/36.svg?v=12', translationKey: 'ui.olympic' },
        { key: 'winter-olympic', route: '/mobile/rules/page-betting-rules-winter-olympic', icon: '/images/icon-sport-svg/38.svg?v=12', translationKey: 'ui.winter_olympic' }
      ];
    }
  },
  methods: {
    hide() {
      const body = document.body;
      if (body.classList.contains('snapjs-left')) {
        body.classList.remove('snapjs-left');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.betting-rules-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-radius: 8px;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: rgba(0, 123, 255, 0.1);
  }
  
  .icon {
    width: 24px;
    height: 24px;
    margin-right: 12px;
    flex-shrink: 0;
  }
  
  span {
    font-weight: 500;
    color: #333;
  }
}

.mt-2 {
  margin-top: 8px;
}
</style>
